import React, { Component } from 'react';
import {
    db,
    COLLECTION_BOOKINGS,
    COLLECTION_BOOKING_DATES_REF,
} from '../../firebase';
import logger from '../../services/logger';
import {
    createManualBookingData,
    createDateTimeBookingData,
    createTimestampFromMoment,
} from '../../utils';

const generateError = (bookingCount) => {
    const p = 1 < bookingCount
        ? `There are ${bookingCount} overlapping bookings that already exists for this timeslot.`
        : 'There is 1 overlapping booking that already exists for this timeslot.';

    return 'Could not create booking. ' + p;
};

export function withFormHandler(WrappedComponent) {
    return class extends Component {
        state = {
            isLoading: false,
            isComplete: false,
            hasError: false,
            errorMessage: '',
            postData: null,
        };

        submitForm = values => {
            const { formValues } = this.state;

            this.setState({
                isLoading: true,
                formValues: {...formValues, ...values},
            }, this.validateBooking);
        }

        validateBooking = async () => {
            const { formValues } = this.state;

            // Dirty! Adding a buffer to searches
            const startTime = formValues.startTime.subtract(30, 'minutes');
            const endTime = formValues.endTime.add(30, 'minutes');

            try {
                const snapshot = await db.collection(COLLECTION_BOOKING_DATES_REF)
                    .where('date_time', '>=', createTimestampFromMoment(startTime))
                    .where('date_time', '<=', createTimestampFromMoment(endTime))
                    .get();

                if (!snapshot.empty) {
                    this.setState({ errorMessage: generateError(snapshot.size) });

                    return this.handleError();
                }

                this.createCustomer();
            } catch (e) {
                this.handleError();
            }
        }

        createCustomer = async () => {
            const { formValues } = this.state;

            try {
                const postData = createManualBookingData(formValues);
                const bookingsRef = db.collection(COLLECTION_BOOKINGS);
                const bookingDateTimeRef = db.collection(COLLECTION_BOOKING_DATES_REF);

                await bookingsRef.doc(postData.uuid).set(postData);
                await bookingDateTimeRef.doc(postData.uuid).set(createDateTimeBookingData(postData));
            } catch (e) {
                const error = `Failed creating a manual booking in Firebase: ` + JSON.stringify(e);

                this.handleError(error);
            }

            this.setState({ isComplete: true, isLoading: false });
        }

        handleError = (error = null) => {
            if (error) {
                logger.error(error);
            }

            this.setState({ hasError: true });
        }

        render() {
            const {
                isLoading,
                isComplete,
                hasError,
                formValues,
                errorMessage,
            } = this.state;

            return (
                <WrappedComponent
                    submitForm={this.submitForm}
                    isLoading={isLoading}
                    isComplete={isComplete}
                    hasError={hasError}
                    formValues={formValues}
                    errorMessage={errorMessage}
                    {...this.props}
                />
            );
        }
    }
}
